import { render, staticRenderFns } from "./Casino.vue?vue&type=template&id=10518948&scoped=true"
import script from "./Casino.vue?vue&type=script&lang=js"
export * from "./Casino.vue?vue&type=script&lang=js"
import style0 from "./Casino.vue?vue&type=style&index=0&id=10518948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10518948",
  null
  
)

export default component.exports